import styled from 'styled-components'

import { E_Colors } from '@/helpers/colors'
import { E_ZIndexes } from '@/helpers/consts'
import { hexToRgba } from '@/helpers'
import type { T_DrawerProps } from './drawer'


export const SC_DrawerWrapper = styled.div`
  z-index: ${E_ZIndexes.Level8};
  height: 100%;
`

export const SC_DrawerBackdrop = styled.div<T_DrawerProps>`
  height: 100%;
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: ${hexToRgba(E_Colors.Black, 0.4)};
`

export const SC_DrawerContent = styled.div<{
  $isFullScreen?: boolean
  $height?: number
  $withHeaderCard?: boolean
}>`
  background-color: ${(p) => p.$withHeaderCard ? `${E_Colors.GrayF5F5F7}` : `${E_Colors.White}`};
  width: 100%;
  max-width: 520px;
  border-radius: ${(p) => !p.$isFullScreen ? '24px 24px 0px 0px' : ''};
  padding: ${(p) =>
    p.$withHeaderCard
      ? '0'
      : p.$isFullScreen
        ? '26px 16px 20px'
        : '10px 16px 20px'};
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  overflow-y: auto;
  height: ${(p) => (
    p.$isFullScreen
      ? '100dvh'
      : p.$height
        ? `calc(${p.$height}px)`
        : 'auto'
  )};
`

export const SC_HeadingWithCloseBtnWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 500;
  font-size: 17px;
  padding-top: 10px;

  img {
    cursor: pointer;
  }
`

export const SC_BackWithCloseBtnWrapper = styled.div<{ $withHeaderCard?: boolean }>`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: ${(p) => (p.$withHeaderCard ? '100%' : '')};
  height: ${(p) => (p.$withHeaderCard ? '100%' : '')};
  background-color: ${(p) => (p.$withHeaderCard ? 'transparent' : E_Colors.White)};
  margin-bottom: ${(p) => (p.$withHeaderCard ? '0' : '16px')};

  img {
    cursor: pointer;
  }

  span {
    font-size: 16px;
    font-weight: 600;
    white-space: nowrap;
  }
`

export const SC_HeaderCard = styled.div`
  background-color: ${E_Colors.White};
  border-radius: 0 0 24px 24px;
  padding: 0 16px;
  margin-bottom: 24px;
  height: 60px;

  display: flex;
  align-items: center;
  top: 0;
  z-index: 1;
`

export const SC_Body = styled.div<{ $withHeaderCard?: boolean }>`
  padding: ${(p) => (p.$withHeaderCard ? '0 16px 20px' : '0')};

  height: 100%;
  display: flex;
  flex-direction: column;

  /* этот <div>, который оболочка для children */
  > div {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
  }
`
